import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import { Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField, Select, MenuItem, InputLabel, Button, Tooltip, IconButton, Card, CardHeader, Stack, CircularProgress, Box, Typography, Checkbox, useMediaQuery, List, ListItem, ListItemText, Divider, Menu } from '@mui/material';
import { DataGridPro, GridRow } from '@mui/x-data-grid-pro';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { employeeSunActiveRecordColumns } from '../../../../../services/column-definitions';
import { submitEmployeeSunActiveRecord, deleteEmployeeSunActiveRecord } from '../../../../../services/request';
import { useManager } from '../../../../../pages/Manager';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';
import { formatDateTime } from '../../../../../services/functions';
import { green, red } from '@mui/material/colors';

export default function SunActivePoints () {
  const { managerEmployee: rowData, setManagerEmployee: setRowData, managerEmployee, setManagerEmployees } = useManager();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { mutate, loading, error } = useMutation(submitEmployeeSunActiveRecord);
  const { mutate: deleteMutate } = useMutation(deleteEmployeeSunActiveRecord);
  const [confirmDeleteModal, setConfirmDeleteModal] = React.useState(false);
  const [event, setEvent] = React.useState(''); // "ADD", "EXCHANGE", ""
  const [addEditModal, setAddEditModal] = React.useState(false);
  const [activeData, setActiveData] = React.useState({});
  const [expandedRows, setExpandedRows] = React.useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [menuRow, setMenuRow] = React.useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRow(null);
  };
  localStorage.setItem('season_points', rowData.points_sum);
  localStorage.setItem('klucz', 'wartość');

  const inPoints = rowData.points.filter(record => record.value >= 0).reduce((sum, record) => sum + record.value, 0);
  const exchangesPoints = rowData.points.filter(record => record.value < 0).reduce((sum, record) => sum + record.value, 0);
  const points = inPoints + exchangesPoints;
  console.log('in, out', inPoints, exchangesPoints);


  const handleOpenAddEditModal = rowData => {
    setActiveData(rowData);
    setAddEditModal(true);
  };

  const handleOpenDeleteModal = rowData => {
    setActiveData(rowData);
    setConfirmDeleteModal(true);
  };

  const handleCloseOpenAddEditModal = () => {
    setAddEditModal(false);
    setActiveData({});
    setEvent('');
  };

  const handleAddPoints = () => {
    setEvent('ADD');
    setAddEditModal(true);
  };

  const handleExchangePoints = () => {
    setEvent('EXCHANGE');
    setAddEditModal(true);
  };

  const handleDelete = async id => {
    const { error } = await deleteMutate(id);
    if (!error) {
      setRowData(prev => {
        const deletedPoints = prev.points.find(element => element.id == id);
        const updatedPoints = prev.points.filter(element => element.id !== id);

        return {
          ...prev,
          points: updatedPoints,
          points_sum: rowData.points_sum - deletedPoints.value
        };
      });
      setManagerEmployees(prevEmployees => prevEmployees.map(emp => emp.id === managerEmployee.id
        ? { ...emp, points: emp.points.filter(point => point.id !== id) }
        : emp
      ));
      toast.success('Rekord został usunięty');
    }

    if (error) {
      toast.error('Nie udało się usunąć rekordu');
    }
    setActiveData({});

  };

  const handleSubmit = async values => {
    const id = activeData.id || null;
    const { payload, loading, error } = await mutate(id, values);

    if (!error && !loading) {
      setRowData(prev => {
        let updatedPoints = null;
        let newPointsSum = prev.points_sum;

        if (id) {
          // Edycja istniejącego rekordu
          updatedPoints = prev.points.map(point => point.id === id ? payload : point);

          const oldPoint = prev.points.find(point => point.id === id);
          if (oldPoint) {
            newPointsSum = prev.points_sum - oldPoint.value + payload.value;
          }
        } else {
          // Dodanie nowego rekordu
          updatedPoints = [payload, ...prev.points];
          newPointsSum = prev.points_sum + payload.value;
        }

        return {
          ...prev,
          points: updatedPoints,
          points_sum: newPointsSum
        };
      });

      setManagerEmployees(prevEmployees => prevEmployees.map(emp => emp.id === managerEmployee.id
        ? {
          ...emp,
          points: id
            ? emp.points.map(point => point.id === id ? payload : point
            )
            : [payload, ...emp.points]
        }
        : emp
      )
      );

      toast.success(`Rekord został ${id ? 'edytowany' : 'dodany'}`);
      handleCloseOpenAddEditModal();
      setActiveData({});
    }

    if (error) {
      toast.error(`Nie udało się ${id ? 'edytować' : 'dodać'} rekordu`);
    }
  };


  const handleRowClick = id => {
    setExpandedRows(prev => ({
      [id]: !prev[id] // Przełączanie stanu rozwinięcia
    }));
  };

  const AccordionRow = props => {
    const isExpanded = expandedRows[props.row.id];

    return (
      <div>
        <GridRow {...props} onClick={() => handleRowClick(props.row.id)} />
        {isExpanded && (
          <div
            style={{
              padding: '16px',
              backgroundColor: '#f9f9f9'
            }}
          >
            <Stack direction={'row'} spacing={2} sx={{ ml: '80px' }}>
              <Typography variant="subtitle1">Opis:</Typography>
              <Typography variant="subtitle2">{props.row.description}</Typography>
            </Stack>
          </div>
        )}
      </div>
    );
  };

  return (
    <Stack>
      <Card style={{ height: '100vh', border: '2px solid transparent', overflow: 'auto' }}>
        <CardHeader action={
          loading
            ? <Box sx={{ p: '8px', height: '40px' }}><CircularProgress size={24}/></Box>
            : <>
              <IconButton
                color="primary"
                component="label"
                onClick={() => handleAddPoints(true)}
                size="small"
                sx={{ mr: 1 }}
              >
                <AddCircleIcon />Dodaj
              </IconButton>
              <IconButton
                color="error"
                component="label"
                onClick={() => handleExchangePoints(true)}
                size="small"
              >
                <RemoveCircleIcon />Wymień
              </IconButton>
            </>
        }/>
        <Stack>
          <Typography variant={isMobile ? 'subtitle2' : 'h6'} color={'secondary'} sx={{ mx: 5, py: 2 }}>
            Aktualny stan punktów w sezonie: <u>{rowData.points_sum}</u>
          </Typography>
        </Stack>
        <Typography variant={isMobile ? 'subtitle2' : 'h6'} color={'primary'} sx={{ mx: 5, py: 2 }}>
          Wpływy: {rowData.points
            ? inPoints
            : 0}
        </Typography>
        {isMobile ? (
          <Stack>
            <Divider sx={{ borderColor: green[400] }} flexItem />
            <List>
              {rowData && rowData.points.filter(record => record.value >= 0).map(row => (
                <ListItem key={row.id} divider sx={{ '&.MuiListItem-divider': { borderColor: green[400] } }}>
                  <ListItemText primary={<Typography><b>Punkty:</b> {row.value}</Typography>} secondary={<Stack direction="column">
                    <Divider flexItem />
                    <Typography><b>Autor:</b> {row.author_name}</Typography>
                    <Typography><b>Aplikacja:</b> {row.application}</Typography>
                    <Typography><b>Stanowisko:</b> {row.function_type_display}</Typography>
                    <Typography><b>Kategoria:</b> {row.category_display}</Typography>
                    <Typography><b>Obóz:</b> {row.camp_name}</Typography>
                    <Typography><b>Data dodania:</b> {formatDateTime(row.created_at)}</Typography>
                  </Stack>} />
                  <IconButton onClick={event => handleMenuOpen(event, row)}>
                    <MoreVertIcon />
                  </IconButton>
                </ListItem>
              ))}
            </List>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem onClick={() => {
                handleOpenAddEditModal(menuRow);
                handleMenuClose();
              }}>
                <EditIcon style={{ marginRight: 8 }} color="primary" /> Edytuj
              </MenuItem>
              <MenuItem onClick={() => {
                handleOpenDeleteModal(menuRow);
                handleMenuClose();
              }}>
                <DeleteIcon style={{ marginRight: 8 }} color="error" /> Usuń
              </MenuItem>
            </Menu>
          </Stack>
        ) : <DataGridPro
          autoHeight
          rows={rowData.points === undefined ? [] : rowData.points.filter(record => record.value >= 0)}
          columns={employeeSunActiveRecordColumns(handleOpenAddEditModal, handleOpenDeleteModal)}
          components={{
            Row: AccordionRow,
            NoRowsOverlay: () => (
              <Stack height="20%" alignItems="center" justifyContent="center">
                Brak punktów
              </Stack>
            )
          }}
        />}
        <Box height={40}/>
        <Typography variant={isMobile ? 'subtitle2' : 'h6'} color={'error'} sx={{ mx: 5, py: 2 }}>
          Wymiany : {rowData.points
            ? exchangesPoints
            : 0}
        </Typography>
        {isMobile ? (
          <Stack height="100%">
            <Divider sx={{ borderColor: red[400] }} flexItem />
            <List>
              {rowData && rowData.points.filter(record => record.value < 0).map(row => (
                <ListItem key={row.id} divider sx={{ '&.MuiListItem-divider': { borderColor: red[400] } }}>
                  <ListItemText primary={<Typography><b>Punkty:</b> {row.value}</Typography>} secondary={<Stack direction="column">
                    <Divider flexItem />
                    <Typography><b>Autor:</b> {row.author_name}</Typography>
                    <Typography><b>Aplikacja:</b> {row.application}</Typography>
                    <Typography><b>Stanowisko:</b> {row.function_type_display}</Typography>
                    <Typography><b>Kategoria:</b> {row.category_display}</Typography>
                    <Typography><b>Obóz:</b> {row.camp_name}</Typography>
                    <Typography><b>Data dodania:</b> {formatDateTime(row.created_at)}</Typography>
                  </Stack>} />
                  <IconButton onClick={event => handleMenuOpen(event, row)}>
                    <MoreVertIcon />
                  </IconButton>
                </ListItem>
              ))}
            </List>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
              <MenuItem onClick={() => {
                handleOpenAddEditModal(menuRow);
                handleMenuClose();
              }}>
                <EditIcon style={{ marginRight: 8 }} color="primary" /> Edytuj
              </MenuItem>
              <MenuItem onClick={() => {
                handleOpenDeleteModal(menuRow);
                handleMenuClose();
              }}>
                <DeleteIcon style={{ marginRight: 8 }} color="error" /> Usuń
              </MenuItem>
            </Menu>
          </Stack>
        ) : <DataGridPro
          autoHeight
          rows={rowData.points === undefined ? [] : rowData.points.filter(record => record.value < 0)}
          columns={employeeSunActiveRecordColumns(handleOpenAddEditModal, handleOpenDeleteModal)}
          components={{
            Row: AccordionRow,
            NoRowsOverlay: () => (
              <Stack height="20%" alignItems="center" justifyContent="center">
                Brak punktów
              </Stack>
            )
          }}
        />}
        <ConfirmDialog
          open={confirmDeleteModal}
          setOpen={setConfirmDeleteModal}
          onConfirm={() => handleDelete(activeData.id)}
        >
          <p>Czy na pewno chcesz usunąć rekord <b>{activeData?.value}</b>?</p>
        </ConfirmDialog>
      </Card>
      <FormModal
        open={addEditModal}
        onClose={handleCloseOpenAddEditModal}
        handleSubmit={handleSubmit}
        data={activeData}
        event={event}
      />
    </Stack>
  );
}


const FormModal = ({ open, onClose, handleSubmit, data, event }) => {
  const { managerEmployee: rowData, choices, application, weekPeriod } = useManager();
  const isMobile = useMediaQuery('(max-width:600px)');

  const categoryType =
    event === 'ADD'
      ? 1
      : event === 'EXCHANGE'
        ? 2
        : null;

  const categories = React.useMemo(() => {
    if (!categoryType) {
      return [];
    }

    return (choices.sun_active_dynamic_categories || []).filter(
      c => c.type === categoryType
    );
  }, [choices, categoryType]);

  const formik = useFormik({
    initialValues: {
      employee: rowData.employee,
      application: rowData.id,
      camp:
        application.periods_type === 'obozy' && !data.camp
          ? weekPeriod.period.id.split('-').pop()
          : data.camp || null,
      dynamic_category: data.dynamic_category || '',
      value: data.value || 0,
      description: data.description || ''
    },
    validate: values => {
      const errors = {};
      const newPointsSum =
        rowData.points_sum - (data.value || 0) + Number(values.value);

      if (newPointsSum < 0) {
        errors.value = 'Całkowita suma punktów pracownika nie może być ujemna.';
      }

      if (event === 'ADD' && values.value <= 0) {
        errors.value = 'Wartość musi być większa niż 0.';
      }

      if (event === 'EXCHANGE' && values.value >= 0) {
        errors.value = 'Wartość musi być mniejsza niż 0.';
      }

      return errors;
    },
    validateOnChange: false,
    onSubmit: handleSubmit
  });

  React.useEffect(() => {
    formik.setValues({
      employee: rowData.employee,
      application: rowData.id,
      camp:
        application.periods_type === 'obozy' && !data.camp
          ? weekPeriod.period.id.split('-').pop()
          : data.camp || null,
      dynamic_category: data.dynamic_category || '',
      value: data.value || 0,
      description: data.description || ''
    });
    formik.setErrors({});
  }, [data]);

  const selectedCategory = categories.find(
    c => c.id === formik.values.dynamic_category
  );

  const isValueDisabled = selectedCategory?.value !== null;

  const handleCategoryChange = e => {
    const categoryId = e.target.value;
    const selected = categories.find(c => c.id === categoryId);

    if (!selected) {
      return;
    }

    formik.setFieldValue('dynamic_category', selected.id);

    if (selected.value !== null) {
      const finalValue =
        event === 'EXCHANGE'
          ? -Math.abs(selected.value)
          : Math.abs(selected.value);

      formik.setFieldValue('value', finalValue);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} sx={{ width: '100%' }}>
      <DialogTitle>
        {data.id
          ? 'Edytuj punkty'
          : event === 'ADD'
            ? 'Dodaj punkty'
            : 'Wymień punkty'}
      </DialogTitle>

      <DialogContent sx={{ minWidth: isMobile ? '200px' : '400px' }}>
        <Box sx={{ height: 20 }} />
        <Stack spacing={2}>
          <FormControl fullWidth>
            <InputLabel>Kategoria</InputLabel>
            <Select
              name="dynamic_category"
              value={formik.values.dynamic_category}
              onChange={handleCategoryChange}
            >
              {categories.map(cat => (
                <MenuItem key={cat.id} value={cat.id} style={{ whiteSpace: 'normal' }}>
                  {cat.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            name="value"
            fullWidth
            label="Wartość"
            type="number"
            value={formik.values.value}
            disabled={isValueDisabled}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.value)}
            helperText={
              isValueDisabled
                ? 'Wartość może zostać ustalona automatycznie przez kategorię'
                : formik.errors.value
            }
          />
          <TextField
            name="description"
            multiline
            rows={4}
            fullWidth
            label="Opis"
            value={formik.values.description}
            onChange={formik.handleChange}
          />
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={formik.handleSubmit}
          color="primary"
          variant="contained"
        >
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};

